/* global $ */

class FirstView {
  constructor() {
    this.class = $('.HeroBgRectMove');

    this.resize();

    // window.loadのタイミングでmain.appから呼び出していたのでここでまたshow()を呼ぶ必要は無い…？
    /*
    setTimeout(() => {
      this.show();
    }, 600);
    */
  }

  show() {
    this.resize();
    setTimeout(() => {
      this.class.addClass('HeroBgRectMove--fadeIn');
    }, 400);
    
  }

  resize() {
    const root = document.querySelector(':root');
    let heroBodyHeight = parseInt($(".HeroBody").height());
    root.style.setProperty('--hero-border-width', `${heroBodyHeight}px`);
    root.style.setProperty('--hero-border-width-half', `${heroBodyHeight / 2}px`);
  }
}
export default FirstView;


